/* eslint-disable global-require */
const axios = require('axios')

const url = 'https://bot-ia.manyconvert.com'

async function getBots(accountId) {
  const attendentsList = await axios.get(
    `${url}/${accountId}/bot`,
  )

  return attendentsList.data.bots
}

async function buscaBot(botId) {
  const attendentsList = await axios.get(
    `${url}/bot/${botId}`,
  )

  return attendentsList.data
}

async function editInfosMetaAccount(botId, code, phone_number_id, waba_id, business_id) {
  const attendentsList = await axios.post(
    `${url}/meta/auth/token`, {
      code, botId, phone_number_id, waba_id, business_id,
    },
  )

  return attendentsList.data
}

async function editRoleBot(botId, data) {
  const attendentsList = await axios.post(
    `${url}/bot/role/${botId}`, data,
  )

  return attendentsList.data
}

async function saveKnowledge(data, botId) {
  const attendentsList = await axios.post(
    `${url}/bot/knowledge/${botId}`, data,
  )

  return attendentsList.data
}

async function getMessage(message, accountId, userId) {
  const attendentsList = await axios.get(
    `${url}/bot/chat/teste/${accountId}/${userId}?mensagem=${message}`,
  )

  return attendentsList.data
}

async function editBot(botId, data) {
  const attendentsList = await axios.patch(
    `${url}/bot/${botId}`, data,
  )

  return attendentsList.data
}

async function createBot(botId, data) {
  const attendentsList = await axios.post(
    `${url}/bot/${botId}`, data,
  )

  return attendentsList.data
}

async function buscaCategorias() {
  const categorias = await axios.get(
    `${url}/categories/all`,
  )

  console.log('aqui: 2 ', categorias.data.categories)
  return categorias.data.categories
}

async function interromperAtendimentoBot(chatToken, data) {
  const atendimentoBot = await axios.post(
    `${url}/agente/stop/${chatToken}`, data,
  )
  console.log(atendimentoBot)
  return atendimentoBot
}

module.exports = {
  getBots, buscaBot, editInfosMetaAccount, editRoleBot, saveKnowledge, getMessage, editBot, createBot, buscaCategorias, interromperAtendimentoBot,
}
